import { render, staticRenderFns } from "./DlvN_Items_List.vue?vue&type=template&id=02c12826"
import script from "./DlvN_Items_List.vue?vue&type=script&lang=js"
export * from "./DlvN_Items_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports